//imports
import {
    BRANDS_EDIT_BRAND_OPEN_MODAL,
    BRANDS_EDIT_BRAND_CLOSE_MODAL,
    BRANDS_EDIT_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_RESULT,
    BRANDS_EDIT_BRAND_GET_BRAND_REQUEST,
    BRANDS_EDIT_BRAND_GET_BRAND_RESULT,
    BRANDS_EDIT_NEW_BRAND_REQUEST,
    BRANDS_EDIT_NEW_BRAND_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    newBrand: null,
    editBrand: null,
    loading: false,
    openModal: false,
    brand: null
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case BRANDS_EDIT_BRAND_OPEN_MODAL:
            return { ...state, openModal: true, loading: true }

        case BRANDS_EDIT_BRAND_CLOSE_MODAL:
            return { ...state, openModal: false }

        case BRANDS_EDIT_BRAND_REQUEST:
            return { ...state, loading: true }

        case BRANDS_EDIT_BRAND_RESULT:
            return { ...state, loading: false, editBrand: action.payload }

        case BRANDS_EDIT_BRAND_GET_BRAND_REQUEST:
            return { ...state, loading: true }

        case BRANDS_EDIT_BRAND_GET_BRAND_RESULT:
            return { ...state, brand: action.payload, loading: false }

        case BRANDS_EDIT_NEW_BRAND_REQUEST:
            return { ...state, loading: true }
        case BRANDS_EDIT_NEW_BRAND_RESULT:
            return { ...state, loading: false, newBrand: action.payload }

        case CLEAR_REDUX:
            return ["", "EDIT_BRAND"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};